import { ChemicalRobPortCallBM } from '../../types/BusinessModel/TankCleaning/ChemicalRobPortCallBM';
import { ChemicalRobPortCall } from '../../types/ViewModel/TankCleaning/ROB/ChemicalRobPortCall';
import { createChemicalRobList } from './ChemicalRobItemFactory';

export const createChemicalRobPortCall = (chemicalRobPortCall: ChemicalRobPortCallBM | null): ChemicalRobPortCall => {
    if (chemicalRobPortCall) {
        return {
            chemicalRobId: chemicalRobPortCall.chemicalRobId,
            portCallId: chemicalRobPortCall.portCallId,
            imoNumber: chemicalRobPortCall.imoNumber,
            createdBy: chemicalRobPortCall.createdBy,
            createdUtc: chemicalRobPortCall.createdUtc,
            lastUpdatedBy: chemicalRobPortCall.lastUpdatedBy,
            lastUpdatedUtc: chemicalRobPortCall.lastUpdatedUtc,
            chemicalRobItemList: createChemicalRobList(chemicalRobPortCall.chemicalRobItemList),
        };
    }
};

export const createChemicalRobPortCallList = (chemicalRobPortCallList: ChemicalRobPortCallBM[]) =>
    chemicalRobPortCallList?.map((chemicalRobPortCall) => createChemicalRobPortCall(chemicalRobPortCall));
